<div class="row grid-row">
    <div class="col-md-1 col-sm-1 grid-column" hznTestId="capacity-report-row-club">{{ item.club }}</div>
    <div class="col-md-3 col-sm-3 grid-column">{{ item.campName }}</div>
    <div class="col-md-3 col-sm-3 grid-column" hznTestId="capacity-report-row-session">{{ item.sessionName }}</div>
    <div class="col-md-2 col-sm-2 grid-column" hznTestId="capacity-report-row-date">
        {{ item.date | bcDate: "YYYY-MM-DD" }}
    </div>
    <div class="col-md-1 col-sm-1 grid-column">
        @if (!item.isUnlimited) {
            <span>{{ item.totalCapacity }}</span>
        }
        @if (item.isUnlimited) {
            <span>{{ "CapacityReport.UnlimitedLabel" | translate }} </span>
        }
    </div>
    <div class="col-md-1 col-sm-1 grid-column">{{ item.usedCapacity }}</div>
    <div class="col-md-1 col-sm-1 grid-column">
        {{ item.usedCapacityPercent | number: "1.0-2" }} %
    </div>
</div>
